/*
CUSTOM SideNavApp
*/

import React, { Component } from "react";
import SideNav, { NavIcon, NavItem, NavText } from "@trendmicro/react-sidenav";
import SUBMIT_EXPERIMENT from "../../gpap-lib/img/icons/clean-hands.svg";
import SUBMIT_FILES from "../../gpap-lib/img/icons/publish.svg";
import HOME from "../../gpap-lib/img/icons/HOME.svg";
import FOLDER from "../../gpap-lib/img/icons/folder.svg";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import IconButton from "@material-ui/core/IconButton";
import EngineeringIcon from "@mui/icons-material/Engineering";
import "./sidenav_custom.css";

import auth from "../Auth";

function renderNavElements(self) {
  return navElements.map((navElement) => {
    const { eventKey, label, icon, alt, text } = navElement;
    return (
      <NavItem
        eventKey={eventKey}
        onMouseOver={() => self.setExpanded(true)}
        onMouseOut={() => self.setExpanded(false)}
      >
        <NavIcon>
          <IconButton aria-label={label}>
            <img src={icon} alt={alt} />
          </IconButton>
        </NavIcon>
        <NavText>{text}</NavText>
      </NavItem>
    );
  });
}

const navElements = [
  {
    eventKey: "HOME",
    label: "home",
    icon: HOME,
    alt: "home icon",
    text: "Home",
  },
  {
    eventKey: "SUBMIT_EXPERIMENTS",
    label: "submit_experiments",
    icon: SUBMIT_EXPERIMENT,
    alt: "dataset submission icon",
    text: "Create new dataset(s)",
  },
  {
    eventKey: "SUBMIT_FILES",
    label: "submit_files",
    icon: SUBMIT_FILES,
    alt: "file submission icon",
    text: "Submit File(s)",
  },
  {
    eventKey: "BROWSE",
    label: "browse",
    icon: FOLDER,
    alt: "browse icon",
    text: "Browse Data",
  },
];

class SideNavApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };

    this.wrapperRef = React.createRef();

    this.setExpanded = this.setExpanded.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (
      this.wrapperRef &&
      event.srcElement.className !== undefined &&
      typeof event.srcElement.className === "string" &&
      !event.srcElement.className.includes("sidenav")
    ) {
      this.setState({ expanded: false });
    }
  }

  setExpanded(bool) {
    this.setState({ expanded: bool });
  }

  render() {
    return (
      <SideNav
        expanded={this.state.expanded}
        ref={this.wrapperRef}
        onSelect={(selected) => {
          const url_fields = window.location.href.split("#");
          let url_to = url_fields;
          switch (selected) {
            case "HOME":
              url_to = `${url_fields[0]}#/`;
              break;
            case "SUBMIT_EXPERIMENTS":
              url_to = `${url_fields[0]}#/createdatasets/selectproject`;
              break;
            case "SUBMIT_FILES":
              url_to = `${url_fields[0]}#/uploadfiles/selectproject`;
              break;
            case "BROWSE":
              url_to = `${url_fields[0]}#/datasets`;
              break;
            case "ADMINISTRATE":
              url_to = `${url_fields[0]}#/administrate`;
              break;
          }
          if (window.location.href != url_to) window.location.href = url_to;
        }}
        onToggle={(expanded) => {
          this.setState({ expanded });
        }}
      >
        <SideNav.Toggle />
        {this.state.expanded ? (
          <div className="username">
            <div className="sc-htoDjs dgwEff">{this.props.username}</div>
          </div>
        ) : null}
        <SideNav.Nav defaultSelected="HOME">
          {renderNavElements(this)}

          {/* below breaks the cypress tests */}
          {/* auth.getUserGroups() breaks cypress */}

          {auth.getUserGroups().includes("admin") ? (
            <NavItem
              eventKey="ADMINISTRATE"
              onMouseOver={() => this.setExpanded(true)}
              onMouseOut={() => this.setExpanded(false)}
            >
              <NavIcon>
                <IconButton aria-label="administrate">
                  <EngineeringIcon />
                </IconButton>
              </NavIcon>
              <NavText>Administrate Data</NavText>
            </NavItem>
          ) : null}
        </SideNav.Nav>
      </SideNav>
    );
  }
}

export default SideNavApp;
